webpackJsonp([432],{

/***/ 1738:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(923),
  /* template */
  __webpack_require__(2192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/inline-manifest-302.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] inline-manifest-302.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4395ad9a", Component.options)
  } else {
    hotAPI.reload("data-v-4395ad9a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2192:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("inline manifest")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_c('code', [_vm._v("manifest")]), _vm._v(" 文件为路径配置和异步组件名字列表，该做法可以减少一个"), _c('code', [_vm._v("http")]), _vm._v("请求。")]), _vm._v(" "), _c('p', [_vm._v("确保 "), _c('code', [_vm._v("vux-loader")]), _vm._v("更新到 "), _c('code', [_vm._v("^1.0.35")]), _vm._v("。")])]), _vm._v(" "), _c('h2', [_vm._v("修改 index.html 模板")]), _vm._v(" "), _c('p', [_vm._v("首先在页面的"), _c('code', [_vm._v("</body>")]), _vm._v("前加入代码：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("%=htmlWebpackPlugin.files.webpackManifest%")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('h2', [_vm._v("配置 vux-loader")]), _vm._v(" "), _c('p', [_vm._v("在"), _c('code', [_vm._v("vux-loader")]), _vm._v("配置的 "), _c('code', [_vm._v("plugins")]), _vm._v(" 列表中加入"), _c('code', [_vm._v("inline-manifest")]), _vm._v("插件")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("plugins:[{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'inline-manifest'")]), _vm._v("\n}]\n")])]), _vm._v(" "), _c('p', [_vm._v("或者简化写法直接使用名字：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("plugins:["), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'inline-manifest'")]), _vm._v("]\n")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4395ad9a", module.exports)
  }
}

/***/ }),

/***/ 766:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1738);

/***/ }),

/***/ 923:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "Vue 打包优化：使用 inline manifest | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ })

});


// WEBPACK FOOTER //
// 432.8ad264eb.js